import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Grid,
  Badge,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import DashboardHeader from "@components/Header/DashboardHeader";
import GenericBreadCrums from "@components/Breadcrumbs";
import { AmenityLocationSection } from "../components/AmenityLocationSection";
import { SiteRoadwaysSection } from "../components/SiteRoadwaysSection";
import { ApplicationStatus } from "../components/ApplicationStatus";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";

import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@store/store";
import { UploadedDocuments } from "../components/UploadedDocuments";
import DescriptionIcon from "@mui/icons-material/Description";
import {
  fetchApplicationDetails,
  fetchReceiptDetailsThunk,
} from "./redux/services/thunk/DetailsThunk";
import { Consent } from "../components/Consent";
// @ts-ignore
import html2pdf from "html2pdf.js";
import check_circle from "@assets/images/logo/Rejected.svg";
import SeekClarificationModel from "@components/slider/SeekClarificationModel";
import SeekClarificationTray from "@components/slider/SeekClarificationTray";
import ConfirmationFinalModal from "@modules/application-section-row/commonModal/ConfirmationFinalModal";
import NoConfirmationFinal from "@modules/application-section-row/commonModal/NoConfirmationFinal";
import RequestExtension from "@modules/application-section-row/commonModal/RequestExtensionModal";
import RequestFinalLicence from "@modules/application-section-row/commonModal/RequestFinalLicenceModal";
import ProvisionalLicense from "@modules/application-section-row/commonModal/ProvisionalLicenseModal";
import FinalLicenseModal from "@modules/application-section-row/commonModal/FinalLicenseModal";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import MuiButton from "@components/Button/MuiButton";
import FinalNOCModal from "@components/Modal/FinalNOCModal";
import { ApplicantOrganisationDetails } from "../components/ApplicantOrganisationDetails";
import { IndividualDetailsPreview } from "../components/IndividualDetails";
import PreviewActionModal from "@components/Modal/PreviewActionModal";
import { Link, useNavigate } from "react-router-dom";
import { MediaUpload } from "../components/MediaUpload";
import RejectRemaks from "@modules/application-section-row/application-details-row/RejectRemaks";
import { app } from "@config/firebaseConfig";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import {
  AlignVerticalBottomOutlined,
  PrintOutlined,
} from "@mui/icons-material";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import QRLicenseGeneratorModal from "../components/QRLicenseGeneratorModal";
import { set } from "lodash";
import {
  BankGuarantee,
  BankGuaranteeDetails,
} from "../components/BankGuarantee";
import {
  fetchbankguaranteedetailsThunk,
  getTransactionStatusThunk,
} from "@modules/provisional-payment/redux/thunk/application-detailThunk";
import { openFileBySignedUrl } from "../../../utils/getViewSignedUrlHandler";
import {
  getFileSignedURLMorthThunk,
  getFileSignedURLThunk,
} from "@modules/stepper/redux/thunk/documentThunk";
import ConfirmDialog from "@components/Modal/ConfirmModal";
import { RenewalDetailsSection } from "../components/RenewalDetailsSection";
import WithdrawApplicationModel from "@components/slider/WithdrawDrawer";
import WithdrawRemarks from "@modules/application-section-row/application-details-row/WithdrawRemarks";
import { getObjectKey } from "@components/buttonGroupView/utils";
import { EotDetails } from "../components/EotDetails";
import { RequestReviewDrawer } from "@components/slider/RequestReviewDrawer";

const EMPTY_ARRAY: any[] = [];

export const ApplicationDetails: React.FC = () => {
  const navigate = useNavigate();
  const printRef = useRef<HTMLDivElement | null>(null);
  const [isRequestExtensionOpen, setIsRequestExtensionOpen] = useState(false);
  const [showAlert, setShowAlert] = useState(true);
  const [receiptDetails, setReceiptDetails] = React.useState<any>(null);
  const [openSliderType, setOpenSliderType] = React.useState<null | string>(
    null,
  );
  const [isConfirmationFLOpen, setIsConfirmationFLOpen] = useState(false);
  const [isNoConfirmationFLOpen, setIsNoConfirmationFLOpen] = useState(false);
  const [openseek, setOpenseek] = useState(false);
  const [openClarificationTray, setOpenClarificationTray] = useState(false);
  const [isPaymentOpen, setIsPaymentOpen] = React.useState(false);
  const [isFinalPaymentOpen, setIsFinalPaymentOpen] = React.useState(false);
  const [isUploadMediaOpen, setIsUploadMediaOpen] = React.useState(false);
  const [isProcessing, setIsProcessing] = useState(false); // NEW
  // preview
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isReviewDrawerOpen, setIsReviewDrawerOpen] = useState(false);
  const [anchorElAction, setAnchorElAction] =
    React.useState<null | HTMLElement>(null);
  const [isApplicationDetailsExpanded, setIsApplicationDetailsExpanded] =
    useState({
      individualDetails: true,
      organisationDetails: false,
      ammentiesDetails: false,
      siteRoadways: false,
      renewalDetails: false,
      documents: false,
      uploadMedia: false,
      consent: false,
      bankGuarateeDetails: false,
      eotDetails: false,
    });
  const [bankGuaranteeDetails, setBankGuaranteeDetails] =
    useState<BankGuarantee>();
  const [isRejectModalOpen, setIsRejectModalOpen] = useState<boolean>(false);
  const dispatch = useDispatch<AppDispatch>();

  const { applicationDetails, loading, error } = useSelector(
    (state: RootState) => state.applicationDetails,
  );

  const [isPreviewActionModalOpen, setIsPreviewActionModalOpen] =
    useState(false);
  const [openQR, setOpenQR] = useState(false);
  const [isGenerating, setIsGenerating] = useState<boolean>(false);
  const [timers, setTimers] = useState<any>({});
  const [openWithdrawDrawer, setOpenWithdrawDrawer] = React.useState(false);

  const applicantName = applicationDetails?.created_by_uname || "";
  const amenityName = applicationDetails?.property_type || "";
  const area = applicationDetails?.location_type_name || "";
  const locationAddress = applicationDetails?.address_1 || "";
  const { access_id } = useSelector(
    (state: RootState) => state.amenities || {},
  );

  const applicationId = access_id;

  const fetchTransactionStatus = async (
    application_id: any,
    category: string,
  ) => {
    try {
      const res = await dispatch(
        getTransactionStatusThunk(application_id),
      ).unwrap();
      if (res?.status) {
        navigate(
          "/esign?" +
            (category == "row"
              ? `row=${application_id}`
              : `access=${application_id}`),
        );
      } else {
        navigate(
          "/payment?" +
            (category == "row"
              ? `row=${application_id}`
              : `access=${application_id}`),
        );
      }
    } catch (error) {
      console.error("Error fetching transaction status:", error);
    }
  };

  const handleViewRemarkDocument = (document: any) => {
    if (!document?.upload_path) {
      return;
    }

    openFileBySignedUrl({
      document_name: getObjectKey(document.upload_path),
      dispatch,
      getSignedUrlThunk: document.upload_path.includes("noc")
        ? getFileSignedURLThunk
        : getFileSignedURLMorthThunk,
    });
  };

  const fetchBankGuaranteeDetails = async () => {
    const res = await dispatch(fetchbankguaranteedetailsThunk(access_id));
    setBankGuaranteeDetails(res?.payload);
  };

  useEffect(() => {
    if (access_id) {
      dispatch(fetchApplicationDetails(access_id));
      fetchBankGuaranteeDetails();
    }
  }, [dispatch, access_id]);

  React.useEffect(() => {
    if (applicationId) {
      dispatch(fetchReceiptDetailsThunk(applicationId)).then((res: any) => {
        if (res.payload?.success && Array.isArray(res.payload.data)) {
          setReceiptDetails(res.payload.data);
        }
      });
    }
  }, [applicationId, dispatch]);

  React.useEffect(() => {
    if (!showAlert) return;

    const timer = setTimeout(() => {
      setShowAlert(false);
    }, 8000); // 8 seconds

    return () => clearTimeout(timer);
  }, [showAlert]);

  const {
    application_code,
    status,
    status_id,
    application_date,
    next_step,
    application_status,
    final_licence_url,
    provisional_licence_url,
    final_license_date,
    provisional_license_date,
    tat_info,
    renewal_license_url,
    renewal_license_date,
    provisional_expiry_date,
    final_expiry_date,
    renewal_expiry_date,
    is_legacy,
    current_phase,
    bg_reupload_req,
    ca_provisional_remarks,
    ca_final_remarks,
    ca_renewal_remarks,
  } = applicationDetails || {};

  // Days the remarks UI stays visible after the remark was created
  const VISIBILITY_DAYS = 30;

  // Map each phase directly to its remarks object
  const PHASE_REMARKS_MAP = {
    PROVISIONAL: ca_provisional_remarks,
    FINAL: ca_final_remarks,
    RENEWAL: ca_renewal_remarks,
  } as const;

  // Resolve the remarks object based on the current phase
  const phaseRemarks =
    PHASE_REMARKS_MAP[current_phase as keyof typeof PHASE_REMARKS_MAP] ?? null;

  // Date window check
  const createdAt = phaseRemarks?.created_at;

  const isWithinWindow = (() => {
    if (!createdAt) return false;

    const created = new Date(createdAt).getTime(); // number
    if (isNaN(created)) return false;

    const now = Date.now(); // number
    const diffInMs = now - created;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    return diffInDays >= 0 && diffInDays <= VISIBILITY_DAYS;
  })();

  // Show only when:
  // 1. current_phase is one of PROVISIONAL / FINAL / RENEWAL
  // 2. that phase's remarks object exists (not null)
  // 3. created_at is within the last 30 days
  const showRejectionRemarks = !!phaseRemarks && !!createdAt && isWithinWindow;

  // Expiry = created_at + VISIBILITY_DAYS
  const expiryDate = createdAt
    ? new Date(new Date(createdAt).getTime() + VISIBILITY_DAYS * 86400000)
    : null;

  // Days remaining (rounded down, min 0)
  const daysLeft = createdAt
    ? Math.max(0, Math.floor((expiryDate!.getTime() - Date.now()) / 86400000))
    : 0;

  // Formatted date, e.g. "August 23, 2026"
  const expiryDateLabel = expiryDate?.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  useEffect(() => {
    if (
      !provisional_expiry_date &&
      !final_expiry_date &&
      !renewal_expiry_date
    ) {
      return;
    }

    const interval = setInterval(() => {
      setTimers({
        provisional: getTimeLeft(provisional_expiry_date),
        final: getTimeLeft(final_expiry_date),
        renewal: getTimeLeft(renewal_expiry_date),
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [provisional_expiry_date, final_expiry_date, renewal_expiry_date]);

  if (!applicationDetails) return;

  const rejectRemaks = (() => {
    switch (status_id) {
      case 5: // provisional reject
        return (
          (applicationDetails as any)?.ca_provisional_remarks?.comments || ""
        );
      case 27: // final reject
        return (applicationDetails as any)?.ca_final_remarks?.comments || "";
      case 73: // renewal reject
        return (applicationDetails as any)?.ca_renewal_remarks?.comments || "";
      case 48: // payment reject
        return (applicationDetails as any)?.bg_remarks || "";
      default:
        return "";
    }
  })();

  const rejectRemaksDocument = (() => {
    switch (status_id) {
      case 5: // provisional reject
        return (
          (applicationDetails as any)?.ca_provisional_remarks
            ?.remark_document || ""
        );
      case 27: // final reject
        return (
          (applicationDetails as any)?.ca_final_remarks?.remark_document || ""
        );
      case 73: // renewal reject
        return (
          (applicationDetails as any)?.ca_renewal_remarks?.remark_document || ""
        );
      default:
        return "";
    }
  })();

  const withdrawalRemarks = (() => {
    return (applicationDetails as any)?.withdrawal_details?.remarks || "";
  })();

  const toggleApplicationPreviewSections = (expanded: boolean) => {
    setIsApplicationDetailsExpanded({
      individualDetails: expanded,
      organisationDetails: expanded,
      ammentiesDetails: expanded,
      siteRoadways: expanded,
      documents: expanded,
      uploadMedia: expanded,
      consent: expanded,
      bankGuarateeDetails: expanded,
      renewalDetails: expanded,
      eotDetails: expanded,
    });
  };
  const allCollapsed = Object.values(isApplicationDetailsExpanded).every(
    (value) => value === false,
  );

  const breadcrumbData = [{ label: "Application Details", link: "#" }];

  const applicationDate = provisional_license_date
    ? new Date(provisional_license_date)
    : new Date();
  const currentDate = new Date();

  const oneYearLater = new Date(applicationDate);
  oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);

  const open = Boolean(anchorEl);

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const formattedDate = application_date
    ? new Date(application_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : "";

  const formattedDueDate = tat_info?.deadline
    ? new Date(tat_info?.deadline || "").toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : "";

  const waitForImagesToLoad = async (element: HTMLElement): Promise<void> => {
    const images = Array.from(
      element.querySelectorAll<HTMLImageElement>("img"),
    );

    const promises = images.map((img) => {
      if (img.complete) return Promise.resolve();

      return new Promise<void>((resolve) => {
        img.onload = () => resolve();
        img.onerror = () => resolve();
      });
    });

    await Promise.all(promises);
  };

  const waitForCondition = async (
    condition: () => boolean,
    interval = 100,
  ): Promise<void> => {
    return new Promise((resolve) => {
      const check = () => {
        if (condition()) {
          resolve();
        } else {
          setTimeout(check, interval);
        }
      };
      check();
    });
  };

  const handleDownloadPDF = async (): Promise<void> => {
    if (!printRef.current || isGenerating) return;

    try {
      setIsGenerating(true);

      // 1️⃣ Expand sections
      toggleApplicationPreviewSections(true);

      // 2️⃣ Wait until API loading is finished
      await waitForCondition(() => !loading);

      // 3️⃣ Small delay to let React fully paint UI
      await new Promise((resolve) => setTimeout(resolve, 300));

      // 4️⃣ Wait for images
      await waitForImagesToLoad(printRef.current);

      // 5️⃣ Extra delay for layout stability (very important for MUI)
      await new Promise((resolve) => setTimeout(resolve, 200));

      // 6️⃣ Generate PDF
      await html2pdf()
        .set({
          margin: 0.4,
          filename: `Application_Details_${application_code || "download"}.pdf`,
          html2canvas: {
            scale: 2,
            useCORS: true,
          },
          jsPDF: { unit: "in", format: "a3", orientation: "portrait" },
        })
        .from(printRef.current)
        .save();
    } catch (error) {
      console.error("PDF generation failed:", error);
    } finally {
      setIsGenerating(false);
    }
  };

  const openAction = Boolean(anchorElAction);

  const handleClickAction = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElAction(event.currentTarget);
  };
  const handleCloseAction = () => {
    setAnchorElAction(null);
  };

  const handleOpenseek = () => {
    setOpenseek(true);
  };
  const handleCloseseek = () => {
    setOpenseek(false);
  };

  const handleSideMenuFinalNOC = (tabLabel: string) => {
    setOpenSliderType(tabLabel);
  };

  const hasApprovedEOT = (() => {
    if (status_id !== 10 || !applicationDetails?.eot_details?.length) {
      return false;
    }

    const latestExpiryDate = applicationDetails.eot_details
      .map((item: any) => item.expiry_date)
      .filter(Boolean)
      .sort(
        (a: string, b: string) => new Date(b).getTime() - new Date(a).getTime(),
      )[0];

    if (!latestExpiryDate) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const expiryDate = new Date(latestExpiryDate);
    expiryDate.setHours(0, 0, 0, 0);

    return expiryDate >= today;
  })();

  function handleFinalNOCAction() {
    if (!application_date) {
      console.log("Application date is not available");
      return;
    }

    const isWithinOriginalValidity = currentDate <= oneYearLater;
    if (isWithinOriginalValidity || hasApprovedEOT) {
      handleSideMenuFinalNOC("finalnoc");
    } else {
      setIsRejectModalOpen(true);
      console.log("Action not allowed. More than 1 year passed.");
    }
  }

  const handleViewFile = (doc_name: any) => {
    openFileBySignedUrl({
      document_name: getObjectKey(doc_name),
      dispatch,
      getSignedUrlThunk: doc_name.includes("noc")
        ? getFileSignedURLThunk
        : getFileSignedURLMorthThunk,
    });
  };

  const renderTimeStrip = (label: string, time: any) => {
    const timerText = renderTimer(time);

    if (!timerText) return null;

    const isExpired = timerText === "Your license has expired";

    return (
      <Typography
        className={`body-xs gray-900 py-3 text-center ${
          isExpired ? "bg-red-100" : "bg-orange-100"
        }`}
      >
        {isExpired ? (
          <strong>{timerText}</strong>
        ) : (
          <>
            {label} Ends in <strong>{timerText}</strong>
          </>
        )}
      </Typography>
    );
  };

  const renderStatusBadge = (status: string) => {
    const statusStyles: Record<string, { text: string; bg: string }> = {
      "Inspection Pending": { text: "#9F7803", bg: "#FFF3CD" },
      "Visit Scheduled": { text: "#0471A2", bg: "#D4F0FD" },
      "Report Submitted": { text: "#4CAF50", bg: "#DBEFDC" },
      "Recommended to CA": { text: "#2196F3", bg: "#D3EAFD" },
      "Application Rejected": { text: "#B3261D", bg: "#F0D4D2" },
      "Final Application Rejected": { text: "#B3261D", bg: "#F0D4D2" },
      "Renewal Rejected": { text: "#B3261D", bg: "#F0D4D2" },
      "Payment Pending": { text: "#B86D00", bg: "#FFEACC" },
      "Payment Received": { text: "#43A047", bg: "#D9ECDA" },
      "Forwarded to Competent Authority": { text: "#1976D2", bg: "#D1E4F6" },
      "Provisional NOC Issued": { text: "#6FA135", bg: "#E2ECD7" },
      "EOT Requested": { text: "#AB47BC", bg: "#EEDAF2" },
      "EOT Approved": { text: "#6A1B9A", bg: "#E1D1EB" },
      "EOT Rejected": { text: "#E53935", bg: "#FAD7D7" },
      "Clarification Requested": { text: "#FF7043", bg: "#FFE2D9" },
      "Clarification Updated": { text: "#26A69A", bg: "#D4EDEB" },
      "Final NOC Issued": { text: "#2E7D32", bg: "#D5E5D6" },
      "Application Submitted": { text: "#154321", bg: "#AEDCBA" },
      Draft: { text: "#757575", bg: "#ECECEC" },
      "Scrutiny Pending": { text: "#9F7803", bg: "#FFF3CD" },
      "BG Forfeiture Initiated": { text: "#B3261D", bg: "#F0D4D2" },
    };

    const defaultStyle = { text: "#374151", bg: "#f3f4f6" };
    const style = statusStyles[status] || defaultStyle;

    return (
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          px: 1.5,
          py: 0.5,

          bgcolor: style.bg,
          color: style.text,
          // Added styles as per request
          padding: "4px 10px",
          borderRadius: "6px",
          fontSize: "12px",
          fontWeight: 600,
        }}
      >
        <Box
          component="span"
          sx={{
            display: "inline-block",
            width: 4,
            height: 4,
            borderRadius: "50%",
            bgcolor: style.text,
          }}
        ></Box>
        {status}
      </Box>
    );
  };

  const getTimeLeft = (expiryDate?: string | null) => {
    if (!expiryDate) return null;

    const now = new Date().getTime();
    const expiry = new Date(expiryDate).getTime();

    if (isNaN(expiry)) return null;

    const diff = expiry - now;
    if (diff <= 0) return null;

    return {
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((diff / (1000 * 60)) % 60),
      seconds: Math.floor((diff / 1000) % 60),
    };
  };

  const renderTimer = (time: any) => {
    if (!time) return null; // 👉 don't render strip

    if (
      time.days === 0 &&
      time.hours === 0 &&
      time.minutes === 0 &&
      time.seconds === 0
    ) {
      return "Your license has expired";
    }

    if (time.days === 0) {
      return `${time.hours} Hours ${time.minutes} Minutes ${time.seconds} Seconds`;
    }

    return `${time.days} Days ${time.hours} Hours ${time.minutes} Minutes ${time.seconds} Seconds`;
  };

  const handleOpenReviewDrawer = () => {
    setIsReviewDrawerOpen(true);
  };

  const handleCloseReviewDrawer = () => {
    setIsReviewDrawerOpen(false);
  };

  return (
    <>
      <SeekClarificationModel
        open={openseek}
        onClose={handleCloseseek}
        access_id={access_id}
        onSuccess={() => dispatch(fetchApplicationDetails(access_id))}
      />
      <SeekClarificationTray
        open={openClarificationTray}
        onClose={() => setOpenClarificationTray(false)}
        accessId={access_id}
        access={true}
        fetchAccess={() => dispatch(fetchApplicationDetails(applicationId))}
      />
      <PreviewActionModal
        open={isPreviewActionModalOpen}
        onClose={() => setIsPreviewActionModalOpen(false)}
        applicationId={applicationId}
        receiptDetails={receiptDetails}
      />
      <ConfirmDialog
        open={isRejectModalOpen}
        title="Provisional NOC Expired"
        message="Your Provisional NOC has been expired. Please apply for Extension of the Provisional NOC before proceeding with Final NOC application."
        onConfirm={() => {
          setIsRejectModalOpen(false);
          setIsRequestExtensionOpen(true);
        }}
        onClose={() => setIsRejectModalOpen(false)}
        confirmText="Click here to Proceed"
      />

      {openSliderType === "finalnoc" && (
        <>
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              bgcolor: "rgba(0,0,0,0.3)", // adjust opacity as needed
              zIndex: 1200, // should be less than your modal zIndex
            }}
          />
          <FinalNOCModal
            openSlider={openSliderType === "finalnoc"}
            setOpenSlider={() => setOpenSliderType(null)}
            applicationId={applicationId}
            onSuccess={() => {
              dispatch(fetchApplicationDetails(applicationId));
            }}
          />
        </>
      )}

      <Box className="app-details-wrapper login-root">
        <div className="page-content">
          {/* <DashboardHeader /> */}
          <GenericBreadCrums breadcrumbs={breadcrumbData} className="mt-6" />

          <Box className="app-details-card" ref={printRef}>
            <Box className="application-banner">
              <Box
                className="application-banner-header"
                sx={{ gap: { xs: 2, sm: 0 } }}
              >
                <Typography className="application-id flex gap-4 items-center ">
                  {application_code}
                  {/* <span className="status-badge">
                    {application_status || "NA"}
                  </span> */}
                  {application_status &&
                    renderStatusBadge(
                      applicationDetails?.clk_req_applicant
                        ? "Clarification Requested"
                        : application_status,
                    )}
                </Typography>
                <Box className="banner-buttons">
                  <Box
                    className="banner-buttons"
                    sx={{
                      display: "flex",
                      gap: "10px",
                      position: "relative",
                      flexWrap: "wrap",
                      justifyContent: { xs: "flex-start" },
                    }}
                  >
                    {/* {status_id === 42 && (
                      <Box
                        sx={{ position: "relative", display: "inline-block" }}
                      >
                        {" "}
                        <Button
                          variant="outlined"
                          onClick={handleOpenseek}
                          sx={{
                            borderRadius: "50px",
                            fontFamily: "Inter",
                            border: "1px solid #3A1C73",
                            fontSize: "14px",
                            color: "#3A1C73",
                            fontWeight: 500,
                            px: 2,
                            py: 0.5,
                            background: "#fff",
                            boxShadow: "none",
                            textTransform: "none",
                            height: "40px",
                          }}
                        >
                          {" "}
                          Clarification{" "}
                        </Button>{" "}
                      </Box>
                    )} */}
                    {status_id === 43 && (
                      <Badge
                        badgeContent={1}
                        color="error"
                        overlap="circular"
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                      >
                        <Button
                          variant="outlined"
                          onClick={handleOpenseek}
                          sx={{
                            borderRadius: "50px",
                            fontFamily: "Inter",
                            border: "1px solid #3A1C73",
                            fontSize: "14px",
                            color: "#3A1C73",
                            fontWeight: 500,
                            px: 2,
                            py: 0.5,
                            background: "#fff",
                            boxShadow: "none",
                            textTransform: "none",
                            height: "40px",
                            right: "6%",
                          }}
                        >
                          Clarification
                        </Button>
                      </Badge>
                    )}

                    {status_id === 6 && (
                      <Button
                        variant="contained"
                        className="btn-filled-purple"
                        startIcon={<CreditCardOutlinedIcon />}
                        onClick={(e) => {
                          e.stopPropagation();
                          fetchTransactionStatus(applicationId, "access");
                        }}
                      >
                        Pay Provisional NOC Fee
                      </Button>
                    )}
                    {(status_id === 48 ||
                      applicationDetails?.bg_reupload_req) && (
                      <Button
                        variant="contained"
                        className="btn-filled-purple"
                        sx={{ borderRadius: "2rem !important" }}
                        startIcon={<DescriptionOutlinedIcon />}
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate("/bg-reupload?access=" + applicationId);
                        }}
                      >
                        Submit electronic Bank Guarantee (e-BG)
                      </Button>
                    )}

                    {/* {[8, 9, 10].includes(status_id) && (
                      <Button
                        variant="contained"
                        className="btn-filled-purple"
                        sx={{ borderRadius: "2rem !important" }}
                        startIcon={<DescriptionOutlinedIcon />}
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate("/bg-reupload?access=" + applicationId);
                        }}
                      >
                        Submit Bank Guarantee
                      </Button>
                    )} */}

                    {/* {[8, 9, 10].includes(status_id) && (
                      <>
                        <Button
                          variant="contained"
                          className="btn-filled-purple"
                          onClick={handleClickAction} // or handleApprove / handleReject
                          sx={{ borderRadius: "50px !important" }}
                        >
                          Action
                        </Button>
                      </>
                    )} */}

                    {/* Final NOC Payment Button */}
                    {status_id === 35 && (
                      <Button
                        variant="contained"
                        className="btn-filled-purple"
                        startIcon={<CreditCardOutlinedIcon />}
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate("/final-license-fee");
                        }}
                      >
                        Pay Final NOC Fee
                      </Button>
                    )}

                    {status_id && [8, 9, 10, 11].includes(status_id) && (
                      <>
                        {![9, 11].includes(status_id) && (
                          <Button
                            variant="contained"
                            className="btn-filled-purple"
                            sx={{ borderRadius: "50px !important", ml: 1 }}
                            onClick={() => handleFinalNOCAction()}
                          >
                            Apply For Final NOC
                          </Button>
                        )}

                        {status_id === 8 && (
                          <Button
                            variant="contained"
                            className="btn-outline-purple"
                            sx={{
                              border: "1px solid #3a1c73 !important",
                              borderRadius: "50px !important",
                              background: "#fff",
                            }}
                            onClick={() => setIsRequestExtensionOpen(true)}
                          >
                            Request Extension of Provisional NOC
                          </Button>
                        )}
                      </>
                    )}
                    {status_id &&
                      [10, 11, 53, 54, 55, 56, 60, 61].includes(status_id) && (
                        <Button
                          variant="contained"
                          className="btn-outline-purple"
                          sx={{
                            border: "1px solid #3a1c73 !important",
                            borderRadius: "50px !important",
                            background: "#fff",
                          }}
                          onClick={() => setIsRequestExtensionOpen(true)}
                        >
                          Re-Apply Extension of Provisional NOC
                        </Button>
                      )}
                    {(status_id === 14 || status_id === 79) && (
                      <Button
                        variant="contained"
                        className="btn-filled-purple"
                        startIcon={<CreditCardOutlinedIcon />}
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(
                            `/apply-renewal?access=${applicationDetails?.id}&category=${applicationDetails?.application_category}`,
                          );
                        }}
                      >
                        Apply for Renewal
                      </Button>
                    )}

                    {((current_phase &&
                      current_phase == "PROVISIONAL" &&
                      status_id != 7 &&
                      status_id != 8 &&
                      status_id != 81) ||
                      status_id == 85) && (
                      <Button
                        variant="contained"
                        className="btn-outline-purple"
                        startIcon={<AssignmentReturnIcon />}
                        sx={{
                          border: "1px solid #3a1c73 !important",
                          borderRadius: "50px !important",
                          color: "#3a1c73",
                          ml: 1,
                          boxShadow: "none",
                          bgcolor: "#fff",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenWithdrawDrawer(true);
                        }}
                      >
                        Withdraw Application
                      </Button>
                    )}

                    {applicationDetails?.clk_req_applicant && (
                      <Badge
                        badgeContent="1"
                        color="error"
                        overlap="circular"
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        sx={{
                          "& .MuiBadge-badge": {
                            // minWidth: 20,
                            // height: 20,
                            borderRadius: "50%",
                            fontWeight: 600,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "2px solid #fff",
                            top: 6,
                            right: 6,
                          },
                        }}
                      >
                        <Button
                          variant="outlined"
                          onClick={() => setOpenClarificationTray(true)}
                          sx={{
                            border: "1.5px solid #3A1C73",
                            borderRadius: "24px",
                            // minWidth: "160px",
                            // height: "40px",
                            color: "#3A1C73",
                            textTransform: "none",
                            fontWeight: 500,
                            backgroundColor: "#fff",
                            fontSize: 14,

                            "&:hover": {
                              border: "1.5px solid #3A1C73",
                              backgroundColor: "#F8F5FF",
                            },
                          }}
                        >
                          Seek Clarification
                        </Button>
                      </Badge>
                    )}
                    <Button
                      variant="outlined"
                      className="btn-outline-purple"
                      onClick={handleDownloadPDF}
                      sx={{
                        border: "1px solid #3a1c73 !important",
                        padding: "10px 2px",
                        borderRadius: "50px !important",
                        width: "40px !important",
                        color: "#3a1c73",
                        ml: 1,
                        visibility: isGenerating ? "hidden" : "visible",
                      }}
                    >
                      <FileDownloadIcon />
                    </Button>

                    {isGenerating && (
                      <CircularProgress
                        size={30}
                        sx={{ position: "absolute", right: 20 }}
                      />
                    )}
                  </Box>
                </Box>
              </Box>

              <Box
                className="application-subinfo"
                sx={{
                  flexWrap: "wrap",
                  gap: { xs: 1, md: 2 },
                  mt: { xs: 2, md: 0 },
                }}
              >
                <Typography className="app-date">
                  Application Date: <strong>{formattedDate}</strong>
                </Typography>
                {next_step && (
                  <Typography className="app-next-step">
                    Next Steps:{" "}
                    <strong>
                      {application_status == "Final NOC Issued"
                        ? "License Renewal"
                        : next_step}
                    </strong>
                  </Typography>
                )}
                {tat_info && (
                  <Typography className="app-payment-due">
                    {tat_info?.tat_description}:{" "}
                    <strong>
                      {formattedDueDate}{" "}
                      {tat_info?.remaining_days != null &&
                        `(${tat_info.remaining_days} days left)`}
                    </strong>
                  </Typography>
                )}
              </Box>
              {showAlert &&
                status_id != null &&
                [
                  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15, 18, 25, 27, 28,
                  31, 33, 35, 37, 40, 42, 43, 48, 49, 51, 52, 57, 62, 63, 68,
                  69, 72, 73, 74, 75, 76, 77, 78, 79, 81, 85,
                ].includes(status_id) && (
                  <Box
                    className="application-alert"
                    sx={{
                      background: [5, 11, 27, 48, 62, 81].includes(status_id)
                        ? "linear-gradient(90deg, #B3261D 0%, #B3261D 100%)"
                        : "linear-gradient(90deg, #60bc6b 0%, #60bc6b 100%)",
                    }}
                  >
                    <Box className="alert-icon">
                      <CircleNotificationsIcon
                        fontSize="medium"
                        className="alert-notification-icon"
                      />
                    </Box>
                    {status_id === 1 && (
                      <Typography className="alert-text">
                        Your Application ID: {application_code} is currently in
                        Draft mode. Please complete and submit to proceed
                        further.
                      </Typography>
                    )}
                    {status_id === 2 && (
                      <Typography className="alert-text">
                        {is_legacy
                          ? `This application has been onboarded on the Rajmarg Pravesh Portal.`
                          : `Congratulations! Your Application ID: ${application_code}
                          has been submitted successfully.`}
                      </Typography>
                    )}
                    {status_id === 3 && (
                      <Typography className="alert-text">
                        Good news! A site visit has been scheduled for your
                        Application ID: {application_code}. Please be available
                        on the assigned date.
                      </Typography>
                    )}
                    {status_id === 4 && (
                      <Typography className="alert-text">
                        Your Application ID: {application_code} is under
                        scrutiny by the authority. Kindly wait for further
                        updates.
                      </Typography>
                    )}
                    {status_id === 5 && (
                      <Typography className="alert-text">
                        We regret to inform you that your Application ID:{" "}
                        {application_code} has been rejected. Please check
                        remarks and reapply if eligible.
                      </Typography>
                    )}
                    {status_id === 27 && (
                      <Typography className="alert-text">
                        We regret to inform you that your Application ID:{" "}
                        {application_code} has been rejected. Please check
                        remarks and reapply if eligible.
                      </Typography>
                    )}
                    {status_id === 6 && (
                      <Typography className="alert-text">
                        Action Required! Your Application ID: {application_code}{" "}
                        has received in-principle approval. Please complete the
                        payment to proceed further.
                      </Typography>
                    )}
                    {status_id === 7 && (
                      <Typography className="alert-text">
                        Thank you! Payment has been received successfully for
                        your Application ID: {application_code}.
                      </Typography>
                    )}
                    {status_id === 8 && (
                      <Typography className="alert-text">
                        {is_legacy
                          ? `This application has been onboarded on the Rajmarg Pravesh Portal.`
                          : `Congratulations! A Provisional NOC has been issued for Application ID: ${application_code}. Download your license from the portal.`}
                      </Typography>
                    )}
                    {status_id === 9 && (
                      <Typography className="alert-text">
                        Your request for Extension of Provisional NOC has been
                        submitted for Application ID: {application_code}.
                      </Typography>
                    )}
                    {status_id === 10 && (
                      <Typography className="alert-text">
                        Congratulations! Your Provisional NOC Extension request
                        for Application ID: {application_code} has been
                        approved.
                      </Typography>
                    )}
                    {status_id === 11 && (
                      <Typography className="alert-text">
                        We regret to inform you that your Provisional NOC
                        Extension request for Application ID: {application_code}{" "}
                        has been rejected. Please review remarks and take
                        further action.
                      </Typography>
                    )}
                    {status_id === 12 && (
                      <Typography className="alert-text">
                        Clarification has been requested by the Competent
                        Authority for Application ID: {application_code}. Please
                        provide the required details at the earliest.
                      </Typography>
                    )}
                    {status_id === 43 && (
                      <Typography className="alert-text">
                        Clarification has been requested by the Competent
                        Authority for Application ID: {application_code}. Please
                        provide the required details at the earliest.
                      </Typography>
                    )}
                    {status_id === 40 && (
                      <Typography className="alert-text">
                        Clarification has been requested by the Competent
                        Authority for Application ID: {application_code}. Please
                        provide the required details at the earliest.
                      </Typography>
                    )}
                    {status_id === 42 && (
                      <Typography className="alert-text">
                        Clarification has been submitted successfully for
                        Application ID: {application_code}. Awaiting further
                        review by the Competent Authority.
                      </Typography>
                    )}
                    {status_id === 14 && (
                      <Typography className="alert-text">
                        {is_legacy
                          ? `This application has been onboarded on the Rajmarg Pravesh Portal.`
                          : `Congratulations! Final NOC has been issued for Application ID: ${application_code}. Download your license from the portal.`}
                      </Typography>
                    )}
                    {status_id === 15 && (
                      <Typography className="alert-text">
                        Your renewal application for Application ID:{" "}
                        {application_code} has been submitted successfully.
                      </Typography>
                    )}
                    {status_id === 18 && (
                      <Typography className="alert-text">
                        Congratulations! Your Application ID:
                        {application_code} has been submitted successfully.
                      </Typography>
                    )}
                    {status_id === 25 && (
                      <Typography className="alert-text">
                        Congratulations! Your Application ID:
                        {application_code} has been submitted successfully.
                      </Typography>
                    )}
                    {status_id === 28 && (
                      <Typography className="alert-text">
                        Thank you! Payment has been received successfully for
                        your Application ID: {application_code}.
                      </Typography>
                    )}
                    {status_id === 31 && (
                      <Typography className="alert-text">
                        Good news! A site visit has been scheduled for your
                        Application ID: {application_code}. Please be available
                        on the assigned date.
                      </Typography>
                    )}
                    {status_id === 33 && (
                      <Typography className="alert-text">
                        Thank you! Payment has been received successfully for
                        your Application ID: {application_code}.
                      </Typography>
                    )}
                    {status_id === 35 && (
                      <Typography className="alert-text">
                        Action Required! Your application with application ID:
                        {application_code} has been approved by the authority.
                        Please complete the payment to proceed further.
                      </Typography>
                    )}
                    {status_id === 37 && (
                      <Typography className="alert-text">
                        Action Required! Your Application ID:
                        {application_code} has received final approval. Please
                        complete the payment to proceed further.
                      </Typography>
                    )}
                    {status_id === 49 && (
                      <Typography className="alert-text">
                        Pending for public comments.
                      </Typography>
                    )}

                    {status_id === 48 && (
                      <Typography className="alert-text">
                        Your electronic Bank Guarantee (e-BG) submitted for
                        Application ID: {application_code} has been rejected.
                        Please review the remarks provided and re-upload the
                        corrected Bank Guarantee for further processing.
                      </Typography>
                    )}
                    {status_id === 51 && (
                      <Typography className="alert-text">
                        EOT Under Review: Your Extension request for Application
                        ID: {application_code} is under review with AS/JS.
                      </Typography>
                    )}
                    {status_id === 52 && (
                      <Typography className="alert-text">
                        EOT Under Review: Your Extension request for Application
                        ID: {application_code} is under review with the
                        Secretary.
                      </Typography>
                    )}
                    {status_id === 62 && (
                      <Typography className="alert-text">
                        Bank Guarantee forfeiture process has been initiated for
                        Application ID: {application_code} as per applicable
                        provisions.
                      </Typography>
                    )}
                    {status_id === 69 && (
                      <Typography className="alert-text">
                        Your renewal application for Application ID:{" "}
                        {application_code} is under scrutiny by the concerned
                        authority. Further updates will be communicated in due
                        course.
                      </Typography>
                    )}
                    {status_id === 63 && (
                      <Typography className="alert-text">
                        Good news! A site visit has been scheduled for your
                        Application ID: {application_code} for renewal. Please
                        be available on the assigned date.
                      </Typography>
                    )}
                    {status_id === 72 && (
                      <Typography className="alert-text">
                        Your renewal application for Application ID:{" "}
                        {application_code} has been approved by the Competent
                        Authority.
                      </Typography>
                    )}
                    {status_id === 73 && (
                      <Typography className="alert-text">
                        Your renewal application for Application ID:{" "}
                        {application_code} has been rejected by the Competent
                        Authority. Kindly refer to the remarks on the portal for
                        further action.
                      </Typography>
                    )}
                    {status_id === 68 && (
                      <Typography className="alert-text">
                        Your Extension request for Application ID:{" "}
                        {application_code} is under review with Competent
                        Authority.
                      </Typography>
                    )}
                    {status_id === 74 && (
                      <Typography className="alert-text">
                        The Renewal NOC for Application ID: {application_code}{" "}
                        has been issued successfully. Please download the
                        renewed license from the portal.
                      </Typography>
                    )}
                    {status_id === 75 && (
                      <Typography className="alert-text">
                        Your Extension request for Application ID:{" "}
                        {application_code} has been returned and is currently
                        under review with the Nodal Officer.
                      </Typography>
                    )}

                    {status_id === 76 && (
                      <Typography className="alert-text">
                        Your E-sign request for Application ID:{" "}
                        {application_code} has been pending. Please complete the
                        E-sign process to proceed further.
                      </Typography>
                    )}
                    {status_id === 77 && (
                      <Typography className="alert-text">
                        Your Application ID: {application_code} is pending for
                        provisional verification by the concerned authority.
                        Please wait for further updates.
                      </Typography>
                    )}
                    {status_id === 78 && (
                      <Typography className="alert-text">
                        Your Application ID: {application_code} is pending for
                        final verification by the concerned authority. Please
                        wait for further updates.
                      </Typography>
                    )}
                    {status_id === 79 && (
                      <Typography className="alert-text">
                        Your Final NOC for Application ID: {application_code} is
                        expiring soon. Kindly initiate the renewal process at
                        the earliest to avoid any disruption.
                      </Typography>
                    )}
                    {status_id === 57 && (
                      <Typography className="alert-text">
                        EOT Under Review: Your Extension request for Application
                        ID: {application_code} is under review with Nodal
                        Officer.
                      </Typography>
                    )}
                    {status_id === 81 && (
                      <Typography className="alert-text">
                        Application withdrawn successfully! Your application
                        with Application ID: {application_code} has been
                        withdrawn and no further processing will be carried out
                        for this application.
                      </Typography>
                    )}

                    {status_id === 85 && (
                      <Typography className="alert-text">
                        Your Application ID: {application_code} is pending for
                        final verification by the concerned authority. Please
                        wait for further updates.
                      </Typography>
                    )}

                    <Box
                      className="alert-close"
                      onClick={() => setShowAlert(false)}
                      style={{ cursor: "pointer" }}
                    >
                      <CloseIcon />
                    </Box>
                  </Box>
                )}
              <br />
              <Divider className="app-divider" />
              <br />

              {final_license_date && final_licence_url && status_id === 14 ? (
                <Box className="license-info-bar rounded-3xl overflow-hidden">
                  {renderTimeStrip("Final NOC", timers.final)}
                  <Box
                    className="license-info-bar"
                    sx={{
                      background: "#EEFFF5",
                      borderRadius: "12px",
                      display: "flex",
                      gap: 2,
                      flexWrap: "wrap",
                      alignItems: "center",
                      justifyContent: "space-between",
                      px: 3,
                      py: 1,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Box
                        sx={{
                          background: "#34A853",
                          borderRadius: "8px",
                          width: 35,
                          height: 35,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <DescriptionIcon sx={{ color: "#fff", fontSize: 22 }} />
                      </Box>
                      <Box>
                        <Typography
                          className="body-xxs"
                          sx={{ fontWeight: 600 }}
                        >
                          Final NOC
                        </Typography>
                        <Typography className="body-xxs gray-900">
                          {final_expiry_date
                            ? (() => {
                                const expiryDate = final_expiry_date
                                  ? new Date(final_expiry_date)
                                  : null;
                                return `Expire on ${expiryDate?.toLocaleDateString(
                                  "en-US",
                                  {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  },
                                )}`;
                              })()
                            : ""}
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          background: "#3A1C73",
                          borderRadius: "999px",
                          textTransform: "none",
                          fontWeight: 500,
                          fontSize: 12,
                          boxShadow: "none",
                          "&:hover": { background: "#2a145c" },
                        }}
                        startIcon={<FileDownloadOutlinedIcon />}
                        onClick={() => {
                          // Replace with your actual download logic
                          if (final_licence_url) {
                            handleViewFile(final_licence_url);
                          }
                        }}
                      >
                        Download
                      </Button>
                      <IconButton
                        sx={{
                          ml: 2,
                          bgcolor: "#3A1C73",
                          "&:hover": {
                            bgcolor: "#2E155D",
                          },
                        }}
                        onClick={() => setOpenQR(true)}
                      >
                        <QrCodeScannerIcon sx={{ color: "#fff" }} />
                      </IconButton>

                      <QRLicenseGeneratorModal
                        open={openQR}
                        onClose={() => setOpenQR(false)}
                        licenseURL={final_licence_url}
                        licenseType="final"
                        moduleType="access"
                      />
                    </Box>
                    {/* <QRLicenseGenerator /> */}
                  </Box>
                </Box>
              ) : (
                <>
                  {provisional_license_date &&
                    provisional_licence_url &&
                    status_id === 8 && (
                      <Box className="license-info-bar rounded-3xl mt-3 overflow-hidden">
                        {renderTimeStrip("Provisional NOC", timers.provisional)}
                        <Box
                          className="license-info-bar"
                          sx={{
                            background: "#EEFFF5",
                            borderRadius: "12px",
                            display: "flex",
                            gap: 2,
                            flexWrap: "wrap",
                            alignItems: "center",
                            justifyContent: "space-between",
                            px: 3,
                            py: 1,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 2,
                            }}
                          >
                            <Box
                              sx={{
                                background: "#34A853",
                                borderRadius: "8px",
                                width: 35,
                                height: 35,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <DescriptionIcon
                                sx={{ color: "#fff", fontSize: 22 }}
                              />
                            </Box>
                            <Box>
                              <Typography
                                className="body-xxs"
                                sx={{ fontWeight: 600 }}
                              >
                                Provisional NOC
                              </Typography>
                              <Typography className="body-xxs gray-900">
                                {provisional_expiry_date
                                  ? (() => {
                                      const expiryDate = new Date(
                                        provisional_expiry_date,
                                      );

                                      return `Expire on ${expiryDate.toLocaleDateString(
                                        "en-US",
                                        {
                                          year: "numeric",
                                          month: "short",
                                          day: "numeric",
                                        },
                                      )}`;
                                    })()
                                  : ""}
                              </Typography>
                            </Box>
                          </Box>
                          <Box>
                            <Button
                              variant="contained"
                              sx={{
                                background: "#3A1C73",
                                borderRadius: "999px",
                                textTransform: "none",
                                fontWeight: 500,
                                fontSize: 12,
                                boxShadow: "none",
                                "&:hover": { background: "#2a145c" },
                              }}
                              startIcon={<FileDownloadOutlinedIcon />}
                              onClick={() => {
                                // Replace with your actual download logic
                                if (provisional_licence_url) {
                                  handleViewFile(provisional_licence_url);
                                }
                              }}
                            >
                              Download
                            </Button>
                            <IconButton
                              sx={{
                                ml: 2,
                                bgcolor: "#3A1C73",
                                "&:hover": {
                                  bgcolor: "#2E155D",
                                },
                              }}
                              onClick={() => setOpenQR(true)}
                            >
                              <QrCodeScannerIcon sx={{ color: "#fff" }} />
                            </IconButton>

                            <QRLicenseGeneratorModal
                              open={openQR}
                              onClose={() => setOpenQR(false)}
                              licenseURL={provisional_licence_url}
                              licenseType="provisional"
                              moduleType="access"
                            />
                          </Box>
                        </Box>
                      </Box>
                    )}
                </>
              )}
              {renewal_license_url && status_id === 74 && (
                <Box className="license-info-bar rounded-3xl mt-3 overflow-hidden">
                  {renderTimeStrip("Renewal NOC", timers.renewal)}
                  <Box
                    className="license-info-bar"
                    sx={{
                      background: "#EEFFF5",
                      borderRadius: "12px",
                      display: "flex",
                      gap: 2,
                      flexWrap: "wrap",
                      alignItems: "center",
                      justifyContent: "space-between",
                      px: 3,
                      py: 1,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Box
                        sx={{
                          background: "#34A853",
                          borderRadius: "8px",
                          width: 35,
                          height: 35,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <DescriptionIcon sx={{ color: "#fff", fontSize: 22 }} />
                      </Box>

                      <Box>
                        <Typography
                          className="body-xxs"
                          sx={{ fontWeight: 600 }}
                        >
                          Renewal NOC
                        </Typography>
                        <Typography className="body-xxs gray-900">
                          {renewal_expiry_date
                            ? (() => {
                                const expiryDate = new Date(
                                  renewal_expiry_date,
                                );
                                return `Expire on ${expiryDate.toLocaleDateString(
                                  "en-US",
                                  {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  },
                                )}`;
                              })()
                            : ""}
                        </Typography>
                      </Box>
                    </Box>

                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          background: "#3A1C73",
                          borderRadius: "999px",
                          textTransform: "none",
                          fontWeight: 500,
                          fontSize: 12,
                          boxShadow: "none",
                          "&:hover": { background: "#2a145c" },
                        }}
                        startIcon={<FileDownloadOutlinedIcon />}
                        onClick={() => {
                          if (renewal_license_url) {
                            handleViewFile(renewal_license_url);
                          }
                        }}
                      >
                        Download
                      </Button>

                      <IconButton
                        sx={{
                          ml: 2,
                          bgcolor: "#3A1C73",
                          "&:hover": {
                            bgcolor: "#2E155D",
                          },
                        }}
                        onClick={() => setOpenQR(true)}
                      >
                        <QrCodeScannerIcon sx={{ color: "#fff" }} />
                      </IconButton>

                      <QRLicenseGeneratorModal
                        open={openQR}
                        onClose={() => setOpenQR(false)}
                        licenseURL={renewal_license_url}
                        licenseType="renewal"
                        moduleType="access"
                      />
                    </Box>
                  </Box>
                </Box>
              )}
              {is_legacy && (status_id == 77 || status_id == 78) && (
                <Typography className="body-xs gray-900 py-3 text-center bg-orange-100">
                  <strong>Dear Applicant</strong> As you are old portal user so
                  you need to update your application to apply for Final NOC and
                  Extension of time (EOT).
                </Typography>
              )}
            </Box>

            {/* {showRejectionRemarks &&
              (status_id === 5 || status_id === 27 || status_id === 73) && (
                <Box
                  sx={{
                    backgroundColor: "#FFF5F5", // Light pinkish background
                    border: "1px solid #FAD7D7",
                    borderRadius: "8px",
                    padding: "16px",
                    marginBottom: "16px",
                    mt: 1,
                  }}
                >
                  <Typography
                    sx={{
                      color: "#B3261D",
                      fontWeight: 600,
                      fontSize: "14px",
                      marginBottom: "8px",
                    }}
                  >
                    Application Rejected Remarks
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "13px",
                      color: "#333",
                      marginBottom: "12px",
                    }}
                  >
                    "{rejectRemaks || "No remarks provided."}"
                  </Typography>
                  <Typography sx={{ fontSize: "13px", color: "#333" }}>
                    <strong style={{ color: "#B3261D" }}>Note:</strong> You can
                    request a review of the application until {expiryDateLabel}{" "}
                    ({daysLeft} {daysLeft === 1 ? "day" : "days"} from now).{" "}
                    <button
                      onClick={handleOpenReviewDrawer}
                      style={{
                        color: "#3A1C73",
                        backgroundColor: "transparent",
                        border: "none",
                        fontWeight: 600,
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      Click here
                    </button>{" "}
                    to appeal.
                  </Typography>
                  {rejectRemaksDocument?.length > 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        mt: 1.5,
                      }}
                    >
                      {rejectRemaksDocument?.map((document: any) => (
                        <Box
                          key={document.id || document.upload_path}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            border: "1px solid #E0E0E0",
                            borderRadius: "8px",
                            padding: "8px 12px",
                            backgroundColor: "#FAFAFA",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              minWidth: 0,
                            }}
                          >
                            <DescriptionOutlinedIcon
                              sx={{
                                color: "#3A1C73",
                                fontSize: 20,
                              }}
                            />

                            <Typography
                              sx={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#212121",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {document.file_name || document.document_name}
                            </Typography>
                          </Box>

                          <Button
                            variant="text"
                            onClick={() => handleViewRemarkDocument(document)}
                            sx={{
                              minWidth: "auto",
                              padding: "4px 8px",
                              color: "#3A1C73",
                              fontSize: "12px",
                              fontWeight: 500,
                              textTransform: "none",
                            }}
                          >
                            View
                          </Button>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              )} */}

            <Grid container spacing={4} justifyContent="center" mt={1}>
              <Grid
                item
                xs={12}
                md={is_legacy && (status_id == 77 || status_id == 78) ? 12 : 8}
              >
                <Box className="app-section-header" mt={0}>
                  <Box className="app-section-title">
                    <Typography className="section-heading">
                      Access Permission Application Details
                    </Typography>
                  </Box>
                  <Box className="app-expand-buttons">
                    {allCollapsed ? (
                      <Button
                        startIcon={
                          <UnfoldMoreIcon className="rotate-45 brand-900" />
                        }
                        onClick={() => toggleApplicationPreviewSections(true)}
                      >
                        <Typography
                          className="brand-900"
                          sx={{ whiteSpace: "nowrap", fontWeight: 700 }}
                        >
                          Expand All
                        </Typography>
                      </Button>
                    ) : (
                      <Button
                        startIcon={
                          <UnfoldLessIcon className="rotate-45 brand-900" />
                        }
                        onClick={() => toggleApplicationPreviewSections(false)}
                      >
                        <Typography
                          className="brand-900"
                          sx={{ whiteSpace: "nowrap", fontWeight: 700 }}
                        >
                          {" "}
                          Collapse All
                        </Typography>
                      </Button>
                    )}
                  </Box>
                </Box>

                <Box className="app-main-content flex flex-col gap-6">
                  <IndividualDetailsPreview
                    isExpanded={isApplicationDetailsExpanded.individualDetails}
                    toggleExpand={() =>
                      setIsApplicationDetailsExpanded((prev) => ({
                        ...prev,
                        individualDetails: !prev.individualDetails,
                      }))
                    }
                    data={applicationDetails}
                  />
                  <ApplicantOrganisationDetails
                    isExpanded={
                      isApplicationDetailsExpanded.organisationDetails
                    }
                    toggleExpand={() =>
                      setIsApplicationDetailsExpanded((prev) => ({
                        ...prev,
                        organisationDetails: !prev.organisationDetails,
                      }))
                    }
                    data={applicationDetails}
                  />
                  <AmenityLocationSection
                    isExpanded={isApplicationDetailsExpanded.ammentiesDetails}
                    toggleExpand={() =>
                      setIsApplicationDetailsExpanded((prev) => ({
                        ...prev,
                        ammentiesDetails: !prev.ammentiesDetails,
                      }))
                    }
                    data={applicationDetails}
                    visible={false}
                  />
                  {
                    <>
                      <SiteRoadwaysSection
                        isExpanded={isApplicationDetailsExpanded.siteRoadways}
                        toggleExpand={() =>
                          setIsApplicationDetailsExpanded((prev) => ({
                            ...prev,
                            siteRoadways: !prev.siteRoadways,
                          }))
                        }
                        data={applicationDetails}
                        visible={false}
                      />
                      <RenewalDetailsSection
                        isExpanded={isApplicationDetailsExpanded.renewalDetails}
                        toggleExpand={() =>
                          setIsApplicationDetailsExpanded((prev) => ({
                            ...prev,
                            renewalDetails: !prev.renewalDetails,
                          }))
                        }
                        applicationId={applicationId}
                        access={true}
                        category={
                          applicationDetails?.application_category || ""
                        }
                      />
                      <UploadedDocuments
                        isExpanded={isApplicationDetailsExpanded.documents}
                        toggleExpand={() =>
                          setIsApplicationDetailsExpanded((prev) => ({
                            ...prev,
                            documents: !prev.documents,
                          }))
                        }
                        visible={false}
                      />
                      <MediaUpload
                        isExpanded={isApplicationDetailsExpanded.uploadMedia}
                        toggleExpand={() =>
                          setIsApplicationDetailsExpanded((prev) => ({
                            ...prev,
                            uploadMedia: !prev.uploadMedia,
                          }))
                        }
                        visible={false}
                      />
                      <Consent
                        isExpanded={isApplicationDetailsExpanded.consent}
                        toggleExpand={() =>
                          setIsApplicationDetailsExpanded((prev) => ({
                            ...prev,
                            consent: !prev.consent,
                          }))
                        }
                      />
                    </>
                  }

                  {
                    <BankGuaranteeDetails
                      data={bankGuaranteeDetails}
                      isExpanded={
                        isApplicationDetailsExpanded.bankGuarateeDetails
                      }
                      toggleExpand={() =>
                        setIsApplicationDetailsExpanded((prev) => ({
                          ...prev,
                          bankGuarateeDetails: !prev.bankGuarateeDetails,
                        }))
                      }
                    />
                  }

                  {(applicationDetails?.eot_details?.length ?? 0) > 0 && (
                    <EotDetails
                      data={(applicationDetails as any)?.eot_details}
                      isExpanded={isApplicationDetailsExpanded.eotDetails}
                      toggleExpand={() =>
                        setIsApplicationDetailsExpanded((prev) => ({
                          ...prev,
                          eotDetails: !prev.eotDetails,
                        }))
                      }
                    />
                  )}
                </Box>
              </Grid>

              <Grid item xs={12} md={4}>
                {(status_id === 5 || status_id === 27 || status_id === 48) && (
                  <RejectRemaks status_id={status_id} remarks={rejectRemaks} />
                )}
                <WithdrawRemarks remarks={withdrawalRemarks} />
                {(!is_legacy || (status_id !== 77 && status_id !== 78)) && (
                  <ApplicationStatus
                    activityLogs={
                      applicationDetails?.activityLogs ?? EMPTY_ARRAY
                    }
                    receiptDetails={receiptDetails}
                    detailsData={applicationDetails}
                  />
                )}
              </Grid>
            </Grid>
          </Box>
        </div>
        {/*start  Upload Media Popup */}

        {/* Payment Popup */}

        <ProvisionalLicense
          applicationDetails={applicationDetails}
          isPaymentOpen={isPaymentOpen}
          setIsPaymentOpen={setIsPaymentOpen}
          applicationId={applicationId}
          applicantName={applicantName}
          amenityName={amenityName}
          area={area}
          locationAddress={locationAddress}
        />

        <FinalLicenseModal
          applicationDetails={applicationDetails}
          isFinalPaymentOpen={isFinalPaymentOpen}
          setIsFinalPaymentOpen={setIsFinalPaymentOpen}
          applicationId={applicationId}
          applicantName={applicantName}
          amenityName={amenityName}
          area={area}
          locationAddress={locationAddress}
        />

        {/* Payment Processing Dialog */}
        <Dialog
          open={isProcessing}
          onClose={() => setIsProcessing(false)}
          maxWidth="xs"
        >
          <DialogTitle className="dialog-title">
            Payment Gateway
            <IconButton
              aria-label="close"
              onClick={() => setIsProcessing(false)}
              className="close-icon"
              sx={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent
            dividers
            className="dialog-content"
            sx={{ textAlign: "center" }}
          >
            <Box className="dot-loader" />
            <Typography variant="subtitle2" className="popup-body">
              Payment Processing
            </Typography>
            <Typography variant="body2" className="dialog-description">
              You will be redirected to the Bharat Kosh portal to finalize your
              payment. Please do not close the page or press the back button
              till the transaction is complete.
            </Typography>
          </DialogContent>
        </Dialog>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleCloseMenu}
          PaperProps={{
            style: {
              boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
              borderRadius: "8px",
            },
          }}
        >
          <MenuItem
            onClick={() => {
              setIsPreviewActionModalOpen(true);
              handleCloseMenu();
            }}
          >
            <FileDownloadOutlinedIcon sx={{ mr: 1 }} />
            Application Fee Receipt
          </MenuItem>

          {provisional_licence_url && (
            <MenuItem
              onClick={() => {
                handleViewFile(provisional_licence_url);
              }}
            >
              <FileDownloadOutlinedIcon sx={{ mr: 1 }} />
              View Provisional NOC
            </MenuItem>
          )}
          {final_licence_url && (
            <MenuItem
              onClick={() => {
                handleViewFile(final_licence_url);
              }}
            >
              <FileDownloadOutlinedIcon sx={{ mr: 1 }} />
              View Final NOC
            </MenuItem>
          )}
        </Menu>
        <RequestExtension
          isRequestExtensionOpen={isRequestExtensionOpen}
          setIsRequestExtensionOpen={setIsRequestExtensionOpen}
          provisionalExpiryDate={provisional_expiry_date}
          applicationId={applicationId}
          onSuccess={() => {
            dispatch(fetchApplicationDetails(applicationId));
          }}
        />
        {/* Request Extension Dialog */}
        <RequestFinalLicence
          isRequestFinalLicenceOpen={isUploadMediaOpen}
          setIsRequestFinalLicenceOpen={setIsUploadMediaOpen}
          applicationId={applicationId}
          onSuccess={() => {
            dispatch(fetchApplicationDetails(applicationId));
          }}
        />
        {/* end */}
        <ConfirmationFinalModal
          isConfirmationFLOpen={isConfirmationFLOpen}
          setIsConfirmationFLOpen={setIsConfirmationFLOpen}
          setIsUploadMediaOpen={setIsUploadMediaOpen}
          setIsNoConfirmationFLOpen={setIsNoConfirmationFLOpen}
        />
        <NoConfirmationFinal
          isNoConfirmationFLOpen={isNoConfirmationFLOpen}
          setIsNoConfirmationFLOpen={setIsNoConfirmationFLOpen}
        />
        <WithdrawApplicationModel
          open={openWithdrawDrawer}
          onClose={() => setOpenWithdrawDrawer(false)}
          access_id={applicationId}
          onSuccess={() => {
            dispatch(fetchApplicationDetails(applicationId));
          }}
        />
        <RequestReviewDrawer
          open={isReviewDrawerOpen}
          onClose={handleCloseReviewDrawer}
          applicationId={applicationId}
          onSuccess={() => {
            dispatch(fetchApplicationDetails(applicationId));
          }}
        />
      </Box>
    </>
  );
};
